<template>
    <div class="field is-horizontal" :class="getButtonClass">
        <bid-update v-if="((this.bid.bids.length > 0 === true))" :bid="bid"></bid-update>
        <bid-place v-if="((this.bid.bids.length <= 0 === true)) && userNotVisitor" :bid="bid"></bid-place>
        <bid-cancel v-if="((this.bid.bids.length > 0 === true))" :bid="bid"></bid-cancel>
        <favorite-delete v-if="((this.bid.favorite.length > 0 === true))" :bid="bid"></favorite-delete>
        <favorite-create v-else :bid="bid"></favorite-create>
        <div class="field" style="padding-right: 15px;">
            <router-link :to="'/single/' + bid.lot_id" class="button  is-small" target="_blank"><i class="fas fa-info-circle"></i></router-link>
        </div>
    </div>
</template>

<script>
    import favoriteCreate from './FavoriteCreate.vue'
    import favoriteDelete from './FavoriteDelete.vue'
    import bidPlace from './BidPlace.vue'
    import bidUpdate from './BidUpdate.vue'
    import bidCancel from './BidCancel.vue'
    export default {
        components: {
            favoriteDelete: favoriteDelete,
            favoriteCreate: favoriteCreate,
            bidPlace: bidPlace,
            bidUpdate: bidUpdate,
            bidCancel: bidCancel
        },
        props: ['bid'],
        data() {
            return {
                lotHasBid: ((this.bid.bids.length > 0 === true)),
                lotIsInFavorites: ((this.bid.favorite.length > 0 === true))

            }
        },
        computed: {
            userNotVisitor () {
                return this.$store.getters.getUserRole !== 'Visitor'
            },
            getButtonClass() {
                if (document.documentElement.clientWidth < 800) {
                    return 'field-mobile'
                } else {
                    return 'field-normal'
                }
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>
    .field-normal {
        float: right;
        padding-top: 5px;
    }
    .field-mobile {
        padding-top: 5px;
        display: -webkit-inline-box;
    }
</style>



// WEBPACK FOOTER //
// src/components/Card/Buttons/Lots/LotButtons.vue